import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function ManHour({isHideSideMenu}) {
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [classificationId, setClassificationId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [locationId, setLocationId] = useState(0);
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState("")

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/paytype/${payTypeId}/month/${month}/year/${year}/classification/${classificationId}/location/${locationId ? locationId : 0}/detailed`;

        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            return response.data
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [classificationId, locationId, month, year, payTypeId]);

    const fetchData2 = useCallback(async () => {
        let apiUrl = 
            `${domain}/api/Reports/paytype/${payTypeId}/year/${year}/classification/${classificationId}/location/${locationId || 0}/detailed2`;

        // Append month only if it exists
        if (month) {
            apiUrl += `/${month}`;
        }

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [classificationId, locationId, month, year, payTypeId]);


    const generate = async () =>{
        setLoading(false);
        setType("PerDay")

        if(!month
            || !year
            || !classificationId
            || !payTypeId
        ){
            setLoading(false);
            setErrorState(true);
            return;
        }
        setErrorState(false);
        
        const logs = await fetchData();
        
        if(logs.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No records found");
            setLoading(false);
            return;
        }

        generateDownloadReport(logs)
    };

    const generateDownloadReport = useCallback(async (data) => {
        const workbook = new ExcelJS.Workbook();

        // 1. Sort Locations alphabetically
        const sortedData = [...data].sort((a, b) => {
            const nameA = a.locationDescription;
            const nameB = b.locationDescription;
            if (!nameA && nameB) return 1;
            if (nameA && !nameB) return -1;
            return (nameA || "").localeCompare(nameB || "");
        });

        for (let i = 0; i < sortedData.length; i++) {
            const locationData = sortedData[i];
            const locationName = locationData.locationDescription || "No Location";
            const worksheet = workbook.addWorksheet(locationName);

            // --- PREPARE DATE LIST FOR THE SELECTED MONTH ---
            const monthsMap = { january:0, february:1, march:2, april:3, may:4, june:5, july:6, august:7, september:8, october:9, november:10, december:11 };
            const mNum = isNaN(month) ? monthsMap[month.toLowerCase()] : parseInt(month) - 1;
            
            const dateList = [];
            const startDate = new Date(Date.UTC(year, mNum, 1));
            const endDate = new Date(Date.UTC(year, mNum + 1, 0));
            let curr = new Date(startDate);
            while (curr <= endDate) {
                dateList.push(curr.toISOString().split("T")[0]);
                curr.setUTCDate(curr.getUTCDate() + 1);
            }

            // --- PREPARE EMPLOYEE LIST ---
            const employeeMap = {};
            locationData.sections.forEach(sec => {
                sec.list.forEach(r => {
                    const id = r.employeePersonalInformationEmployeeId;
                    if (!employeeMap[id]) {
                        employeeMap[id] = { id, name: r.employeePersonalInformationFullName, records: [] };
                    }
                    employeeMap[id].records.push(r);
                });
            });
            const employeeList = Object.values(employeeMap).sort((a, b) => a.name.localeCompare(b.name));

            // --- TABLE 1 (LEFT): SECTION SUMMARY (HOURS WORKED) ---
            const sectionCount = locationData.sections.length;
            worksheet.mergeCells(1, 1, 1, 1 + sectionCount);
            worksheet.getCell(1, 1).value = `SECTION SUMMARY (HOURS WORKED)`;
            
            const headerRow1 = worksheet.getRow(2);
            headerRow1.getCell(1).value = "Date";
            locationData.sections.forEach((sec, idx) => {
                headerRow1.getCell(2 + idx).value = sec.sectionDescription || "No Section";
            });

            dateList.forEach((date, idx) => {
                const row = worksheet.getRow(3 + idx);
                row.getCell(1).value = date;
                locationData.sections.forEach((sec, sIdx) => {
                    // FIXED: Using record.hoursWorked from backend
                    const total = sec.list
                        .filter(r => r.date.startsWith(date))
                        .reduce((sum, r) => sum + (r.hoursWorked || 0), 0);
                    row.getCell(2 + sIdx).value = total;
                    row.getCell(2 + sIdx).numFmt = '#,##0.00';
                });
            });

            // --- TABLE 2 (RIGHT): EMPLOYEE MATRIX (HOURS WORKED) ---
            const gap = 2;
            const table2StartCol = 1 + sectionCount + gap + 1;
            
            worksheet.mergeCells(1, table2StartCol, 1, table2StartCol + 1 + dateList.length + 1);
            worksheet.getCell(1, table2StartCol).value = `EMPLOYEE MATRIX (HOURS WORKED)`;

            const headerRow2 = worksheet.getRow(2);
            headerRow2.getCell(table2StartCol).value = "Employee ID";
            headerRow2.getCell(table2StartCol + 1).value = "Full Name";
            dateList.forEach((date, idx) => {
                headerRow2.getCell(table2StartCol + 2 + idx).value = new Date(date).getUTCDate();
            });
            headerRow2.getCell(table2StartCol + 2 + dateList.length).value = "TOTAL";

            employeeList.forEach((emp, empIdx) => {
                const row = worksheet.getRow(3 + empIdx);
                row.getCell(table2StartCol).value = emp.id;
                row.getCell(table2StartCol + 1).value = emp.name;
                let rowTotal = 0;
                dateList.forEach((date, dIdx) => {
                    // FIXED: Using record.hoursWorked from backend
                    const hours = emp.records
                        .filter(r => r.date.startsWith(date))
                        .reduce((sum, r) => sum + (r.hoursWorked || 0), 0);
                    row.getCell(table2StartCol + 2 + dIdx).value = hours;
                    row.getCell(table2StartCol + 2 + dIdx).numFmt = '#,##0.00';
                    rowTotal += hours;
                });
                row.getCell(table2StartCol + 2 + dateList.length).value = rowTotal;
                row.getCell(table2StartCol + 2 + dateList.length).font = { bold: true };
                row.getCell(table2StartCol + 2 + dateList.length).numFmt = '#,##0.00';
            });

            // --- TABLE 3 (BELOW MATRIX): OVERTIME SUMMARY ---
            const otTableStartRow = 3 + employeeList.length + 3; 
            
            worksheet.mergeCells(otTableStartRow, table2StartCol, otTableStartRow, table2StartCol + 1 + dateList.length + 1);
            const otTitleCell = worksheet.getCell(otTableStartRow, table2StartCol);
            otTitleCell.value = `OVERTIME SUMMARY`;
            otTitleCell.font = { bold: true, size: 12 };
            otTitleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEB9C' } }; 

            const otHeaderRow = worksheet.getRow(otTableStartRow + 1);
            otHeaderRow.getCell(table2StartCol).value = "Employee ID";
            otHeaderRow.getCell(table2StartCol + 1).value = "Full Name";
            dateList.forEach((date, idx) => {
                otHeaderRow.getCell(table2StartCol + 2 + idx).value = new Date(date).getUTCDate();
            });
            otHeaderRow.getCell(table2StartCol + 2 + dateList.length).value = "TOTAL";

            employeeList.forEach((emp, empIdx) => {
                const row = worksheet.getRow(otTableStartRow + 2 + empIdx);
                row.getCell(table2StartCol).value = emp.id;
                row.getCell(table2StartCol + 1).value = emp.name;
                let otRowTotal = 0;
                dateList.forEach((date, dIdx) => {
                    // FIXED: Using record.overtimeSummary from backend
                    const otHours = emp.records
                        .filter(r => r.date.startsWith(date))
                        .reduce((sum, r) => sum + (r.overtimeSummary || 0), 0);
                    row.getCell(table2StartCol + 2 + dIdx).value = otHours;
                    row.getCell(table2StartCol + 2 + dIdx).numFmt = '#,##0.00';
                    otRowTotal += otHours;
                });
                row.getCell(table2StartCol + 2 + dateList.length).value = otRowTotal;
                row.getCell(table2StartCol + 2 + dateList.length).font = { bold: true };
                row.getCell(table2StartCol + 2 + dateList.length).numFmt = '#,##0.00';
            });

            // --- STYLING ---
            [headerRow1, headerRow2, otHeaderRow].forEach(row => {
                row.eachCell(cell => {
                    if (cell.value) {
                        cell.font = { bold: true };
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
                        cell.alignment = { horizontal: 'center' };
                        cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
                    }
                });
            });

            worksheet.eachRow(row => {
                row.eachCell(cell => {
                    cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
                });
            });

            // Column widths
            worksheet.getColumn(1).width = 15; // Date Col
            worksheet.getColumn(table2StartCol).width = 15; // ID Col
            worksheet.getColumn(table2StartCol + 1).width = 35; // Name Col
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `MAN_HOUR_REPORT_${month}_${year}.xlsx`);
    }, [month, year]);

    /* const generateDownloadReport = useCallback(async (data) => {
        const workbook = new ExcelJS.Workbook();

        // Helper: Calculate standard worked hours
        const calculateWorkedHours = (record) => {
            if (!record.timeIn || !record.timeOut) return 0;
            const timeInDate = new Date(record.timeIn);
            const timeOutDate = new Date(record.timeOut);
            const timeDiff = timeOutDate - timeInDate; 
            const hoursWorked = timeDiff / (1000 * 60 * 60); 
            const deduction = (record.late || 0) + (record.undertime || 0);
            return Math.max(0, hoursWorked - deduction);
        };

        // Helper: Calculate Sum of all Overtime fields
        const calculateOTHours = (record) => {
            return (record.overtimeSummary || 0);

            // return (record.otRegular || 0) +
            //     (record.otRestday || 0) +
            //     (record.otHolidaySpecial || 0) +
            //     (record.otHolidayRegular || 0) +
            //     (record.otRestdayHolidaySpecial || 0) +
            //     (record.otRestdayHolidayRegular || 0);
        };

        // 1. Sort Locations
        const sortedData = [...data].sort((a, b) => {
            const nameA = a.locationDescription;
            const nameB = b.locationDescription;
            if (!nameA && nameB) return 1;
            if (nameA && !nameB) return -1;
            return (nameA || "").localeCompare(nameB || "");
        });

        for (let i = 0; i < sortedData.length; i++) {
            const locationData = sortedData[i];
            const locationName = locationData.locationDescription || "No Location";
            const worksheet = workbook.addWorksheet(locationName);

            // --- PREPARE DATE LIST ---
            const monthsMap = { january:0, february:1, march:2, april:3, may:4, june:5, july:6, august:7, september:8, october:9, november:10, december:11 };
            const mNum = isNaN(month) ? monthsMap[month.toLowerCase()] : parseInt(month) - 1;
            
            const dateList = [];
            const startDate = new Date(Date.UTC(year, mNum, 1));
            const endDate = new Date(Date.UTC(year, mNum + 1, 0));
            let curr = new Date(startDate);
            while (curr <= endDate) {
                dateList.push(curr.toISOString().split("T")[0]);
                curr.setUTCDate(curr.getUTCDate() + 1);
            }

            // --- PREPARE EMPLOYEE LIST ---
            const employeeMap = {};
            locationData.sections.forEach(sec => {
                sec.list.forEach(r => {
                    const id = r.employeePersonalInformationEmployeeId;
                    if (!employeeMap[id]) {
                        employeeMap[id] = { id, name: r.employeePersonalInformationFullName, records: [] };
                    }
                    employeeMap[id].records.push(r);
                });
            });
            const employeeList = Object.values(employeeMap).sort((a, b) => a.name.localeCompare(b.name));

            // --- TABLE 1 (LEFT): SECTION SUMMARY ---
            const sectionCount = locationData.sections.length;
            worksheet.mergeCells(1, 1, 1, 1 + sectionCount);
            worksheet.getCell(1, 1).value = `SECTION SUMMARY`;
            
            const headerRow1 = worksheet.getRow(2);
            headerRow1.getCell(1).value = "Date";
            locationData.sections.forEach((sec, idx) => {
                headerRow1.getCell(2 + idx).value = sec.sectionDescription || "No Section";
            });

            dateList.forEach((date, idx) => {
                const row = worksheet.getRow(3 + idx);
                row.getCell(1).value = date;
                locationData.sections.forEach((sec, sIdx) => {
                    const total = sec.list.filter(r => r.date.startsWith(date)).reduce((sum, r) => sum + calculateWorkedHours(r), 0);
                    row.getCell(2 + sIdx).value = total;
                    row.getCell(2 + sIdx).numFmt = '0.00';
                });
            });

            // --- TABLE 2 (RIGHT): EMPLOYEE MATRIX (MAN-HOURS) ---
            const gap = 2;
            const table2StartCol = 1 + sectionCount + gap + 1;
            
            worksheet.mergeCells(1, table2StartCol, 1, table2StartCol + 1 + dateList.length + 1);
            worksheet.getCell(1, table2StartCol).value = `EMPLOYEE MATRIX (MAN-HOURS)`;

            const headerRow2 = worksheet.getRow(2);
            headerRow2.getCell(table2StartCol).value = "Employee ID";
            headerRow2.getCell(table2StartCol + 1).value = "Full Name";
            dateList.forEach((date, idx) => {
                headerRow2.getCell(table2StartCol + 2 + idx).value = new Date(date).getUTCDate();
            });
            headerRow2.getCell(table2StartCol + 2 + dateList.length).value = "TOTAL";

            employeeList.forEach((emp, empIdx) => {
                const row = worksheet.getRow(3 + empIdx);
                row.getCell(table2StartCol).value = emp.id;
                row.getCell(table2StartCol + 1).value = emp.name;
                let rowTotal = 0;
                dateList.forEach((date, dIdx) => {
                    const hours = emp.records.filter(r => r.date.startsWith(date)).reduce((sum, r) => sum + calculateWorkedHours(r), 0);
                    row.getCell(table2StartCol + 2 + dIdx).value = hours;
                    row.getCell(table2StartCol + 2 + dIdx).numFmt = '0.00';
                    rowTotal += hours;
                });
                row.getCell(table2StartCol + 2 + dateList.length).value = rowTotal;
                row.getCell(table2StartCol + 2 + dateList.length).numFmt = '0.00';
            });

            // --- TABLE 3 (BELOW MATRIX): OVERTIME SUMMARY ---
            const otTableStartRow = 3 + employeeList.length + 3; // Gap of 3 rows below matrix
            
            worksheet.mergeCells(otTableStartRow, table2StartCol, otTableStartRow, table2StartCol + 1 + dateList.length + 1);
            const otTitleCell = worksheet.getCell(otTableStartRow, table2StartCol);
            otTitleCell.value = `OVERTIME SUMMARY`;
            otTitleCell.font = { bold: true, size: 12 };
            otTitleCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEB9C' } }; // Light orange/yellow

            const otHeaderRow = worksheet.getRow(otTableStartRow + 1);
            otHeaderRow.getCell(table2StartCol).value = "Employee ID";
            otHeaderRow.getCell(table2StartCol + 1).value = "Full Name";
            dateList.forEach((date, idx) => {
                otHeaderRow.getCell(table2StartCol + 2 + idx).value = new Date(date).getUTCDate();
            });
            otHeaderRow.getCell(table2StartCol + 2 + dateList.length).value = "TOTAL";

            employeeList.forEach((emp, empIdx) => {
                const row = worksheet.getRow(otTableStartRow + 2 + empIdx);
                row.getCell(table2StartCol).value = emp.id;
                row.getCell(table2StartCol + 1).value = emp.name;
                let otRowTotal = 0;
                dateList.forEach((date, dIdx) => {
                    const otHours = emp.records.filter(r => r.date.startsWith(date)).reduce((sum, r) => sum + calculateOTHours(r), 0);
                    row.getCell(table2StartCol + 2 + dIdx).value = otHours;
                    row.getCell(table2StartCol + 2 + dIdx).numFmt = '0.00';
                    otRowTotal += otHours;
                });
                row.getCell(table2StartCol + 2 + dateList.length).value = otRowTotal;
                row.getCell(table2StartCol + 2 + dateList.length).numFmt = '0.00';
            });

            // --- STYLING ---
            // Header rows
            [headerRow1, headerRow2, otHeaderRow].forEach(row => {
                row.eachCell(cell => {
                    if (cell.value) {
                        cell.font = { bold: true };
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
                        cell.alignment = { horizontal: 'center' };
                        cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
                    }
                });
            });

            // Column widths
            worksheet.columns.forEach((col, idx) => {
                if (idx === 0 || idx === table2StartCol - 1) col.width = 15;
                else if (idx === table2StartCol) col.width = 35;
                else col.width = 7;
            });

            // Apply borders to all used data cells
            worksheet.eachRow(row => {
                row.eachCell(cell => {
                    cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
                });
            });
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'MANHOUR_REPORT_WITH_OT.xlsx');
    }, [month, year]); */

    //oldest
    // const generateDownloadReport = useCallback(async (data) => {
    //     const workbook = new ExcelJS.Workbook();

    //     for (let i = 0; i < data.length; i++) {
    //         const worksheet1 = workbook.addWorksheet(`${data[i].locationDescription}`);

    //         // 1. Define the columns (This automatically creates the header row on Row 1 initially)
    //         const columns = [
    //             { header: 'Date', key: 'date', width: 20 },
    //             ...data[i].sections.map(({ sectionId, sectionDescription }) => ({
    //                 header: sectionDescription, // Display name in header
    //                 key: `section_${sectionId}`, // Unique key using sectionId
    //                 width: 30
    //             }))
    //         ];
    //         worksheet1.columns = columns;

    //         // --- NEW/CORRECTED CODE START ---

    //         console.log(`Report for ${month} ${year}`)
    //         // 2. Prepare the Title Text
    //         const titleText = `${data[i].locationDescription} - Report for ${month} ${year}`;
            
    //         // 3. Insert a new row at position 1. This pushes the original header row (Row 1) down to Row 2.
    //         worksheet1.spliceRows(1, 0, [titleText]);
            
    //         // 4. Merge the title cell (now A1) across the full width
    //         const numColumns = columns.length; 
    //         const lastColumnLetter = String.fromCharCode(65 + numColumns - 1); 
    //         worksheet1.mergeCells(`A1:${lastColumnLetter}1`); 
            
    //         // 5. Apply styles to the title cell (A1)
    //         const titleCell = worksheet1.getRow(1).getCell(1);
    //         titleCell.font = { bold: true, size: 16 };
    //         titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
    //         titleCell.height = 30;
    //         titleCell.fill = {
    //             type: 'pattern',
    //             pattern: 'solid',
    //             fgColor: { argb: 'D3D3D3' }, 
    //         };
    //         titleCell.border = {
    //             top: { style: 'medium' },
    //             left: { style: 'medium' },
    //             bottom: { style: 'medium' },
    //             right: { style: 'medium' },
    //         };
            
    //         // --- NEW/CORRECTED CODE END ---

    //         // Apply styles to header row (now Row 2)
    //         const headerRow = worksheet1.getRow(2); // *** IMPORTANT: Now referencing Row 2 ***
    //         worksheet1.getRow(2).height = 25;
            
    //         headerRow.eachCell((cell) => {
    //             cell.font = { bold: true };
    //             cell.alignment = { horizontal: 'center' };
    //             cell.border = {
    //                 top: { style: 'medium' },
    //                 left: { style: 'medium' },
    //                 bottom: { style: 'medium' },
    //                 right: { style: 'medium' },
    //             };
    //             cell.fill = {
    //                 type: 'pattern',
    //                 pattern: 'solid',
    //                 fgColor: { argb: 'EAEAEA' },
    //             };
    //         });

    //         // Converts "November" → 11
    //         const monthToNumber = (month) => {
    //             const months = {
    //                 january: 1, february: 2, march: 3, april: 4,
    //                 may: 5, june: 6, july: 7, august: 8,
    //                 september: 9, october: 10, november: 11, december: 12
    //             };
    //             return months[month.toLowerCase()] || null;
    //         };
        
    //         // Function to generate an array of dates from dateFrom to dateTo
    //         const getDateRange = (month, year) => {
    //             let dates = [];
    //             // ... (getDateRange logic remains the same)
    //             let monthNumber = parseInt(month);
    //             if (isNaN(monthNumber)) {
    //                 monthNumber = monthToNumber(month); 
    //             }
    //             if (!monthNumber) {
    //                 console.error("Invalid month:", month);
    //                 return [];
    //             }
    //             const startDate = new Date(Date.UTC(year, monthNumber - 1, 1));
    //             const endDate = new Date(Date.UTC(year, monthNumber, 0));
    //             let currentDate = startDate;
    //             while (currentDate <= endDate) {
    //                 dates.push(currentDate.toISOString().split("T")[0]);
    //                 currentDate.setUTCDate(currentDate.getUTCDate() + 1);
    //             }
    //             return dates;
    //         };

    //         // Calculate hours worked
    //         const calculateWorkedHours = (section, record, timeIn, timeOut, late, undertime) => {
    //             // ... (calculateWorkedHours logic remains the same)
    //             const timeInDate = new Date(timeIn);
    //             const timeOutDate = new Date(timeOut);
    //             const timeDiff = timeOutDate - timeInDate; // Difference in milliseconds
    //             const hoursWorked = timeDiff / (1000 * 60 * 60); // Convert milliseconds to hours
    //             const deduction = late + undertime;
    //             const total = hoursWorked - deduction;
    //             return total;
    //         };
            
    //         // Generate dates
    //         const dateList = getDateRange(month, year);

    //         // Data rows start here (Row 3 onwards)
    //         dateList.forEach(date => {
    //             const row = worksheet1.addRow([
    //                 date, 
    //                 ...new Array(data[i].sections.length).fill('')
    //             ]);

    //             data[i].sections.forEach((section, sectionIndex) => {
    //                 let totalHoursWorked = 0;
    //                 section.list.forEach(record => {
    //                     if (record.date.startsWith(date)) {
    //                         totalHoursWorked += calculateWorkedHours(section, record, record.timeIn, record.timeOut, record.late, record.undertime);
    //                     }
    //                 });
                
    //                 row.getCell(sectionIndex + 2).value = totalHoursWorked.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //                 row.getCell(sectionIndex + 2).alignment = { horizontal: 'center', vertical: 'middle' };
    //                 row.getCell(sectionIndex + 2).border = { 
    //                     top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
    //                 };
    //             });

    //             row.height = 20; 

    //             row.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    //             row.getCell(1).border = { 
    //                 top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' },
    //             };
    //         });

    //         // Add 'Total' row 
    //         const totalRow = worksheet1.addRow([
    //             'Total', 
    //             ...new Array(data[i].sections.length).fill('')
    //         ]);

    //         let overallTotal = 0;

    //         // ... (Total row calculation and styling logic remains the same) ...
    //         data[i].sections.forEach((section, sectionIndex) => {
    //             let sectionTotal = 0;
    //             dateList.forEach(date => {
    //                 section.list.forEach(record => {
    //                     if (record.date.startsWith(date)) {
    //                         sectionTotal += calculateWorkedHours(section, record, record.timeIn, record.timeOut, record.late, record.undertime);
    //                         overallTotal += calculateWorkedHours(section, record, record.timeIn, record.timeOut, record.late, record.undertime);
    //                     }
    //                 });
    //             });

    //             totalRow.getCell(sectionIndex + 2).value = sectionTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //             totalRow.getCell(sectionIndex + 2).alignment = { horizontal: 'center', vertical: 'middle' };
    //             totalRow.getCell(sectionIndex + 2).border = { top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' } };
    //             totalRow.getCell(sectionIndex + 2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
    //         });

    //         totalRow.height = 20;
    //         totalRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    //         totalRow.getCell(1).border = { top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' } };
    //         totalRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };

    //         // Calculate the overall total for all sections
    //         worksheet1.addRow(); // Empty row

    //         // Overall row
    //         const overallRow = worksheet1.addRow(['Overall', ...new Array(data[i].sections.length).fill('')]);

    //         // ... (Overall row calculation and styling logic remains the same) ...
    //         overallRow.getCell(2).value = overallTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //         overallRow.getCell(2).alignment = { horizontal: 'center', vertical: 'middle' };
    //         overallRow.getCell(2).border = { top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' } };
    //         overallRow.getCell(2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
    //         overallRow.height = 20;

    //         overallRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    //         overallRow.getCell(1).border = { top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' } };
    //         overallRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
    //     }

    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //     saveAs(blob, 'MANHOUR_REPORT_PER_DAY.xlsx');
    // }, [month, year]);

    const generateTotal = async () =>{
        setLoading(false);
        setType("Total")

        if( !year
            || !classificationId
            || !payTypeId
        ){
            setLoading(false);
            setErrorState(true);
            return;
        }
        setErrorState(false);
        
        const logs = await fetchData2();
        
        if(logs.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No records found");
            setLoading(false);
            return;
        }

        generateDownloadReportTotal(logs)
    };

    const generateDownloadReportTotal = useCallback(async (data) => {
        const workbook = new ExcelJS.Workbook();

        const allMonths = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        // --- 1. RE-GROUP DATA BY LOCATION & CALCULATE TOTALS ---
        const locationMap = {};

        data.forEach(monthItem => {
            monthItem.locations.forEach(loc => {
                const locName = loc.locationDescription || "No location";
                if (!locationMap[locName]) {
                    locationMap[locName] = {
                        description: locName,
                        sections: {},
                        employees: {} 
                    };
                }

                loc.sections.forEach(sec => {
                    const secName = sec.sectionDescription || "No Section";
                    if (!locationMap[locName].sections[secName]) {
                        locationMap[locName].sections[secName] = {
                            id: sec.sectionId,
                            description: secName,
                            allRecords: []
                        };
                    }
                    locationMap[locName].sections[secName].allRecords.push(...sec.list);

                    sec.list.forEach(record => {
                        const empId = record.employeePersonalInformationEmployeeId;
                        const monthIdx = new Date(record.date).getMonth();

                        if (!locationMap[locName].employees[empId]) {
                            locationMap[locName].employees[empId] = {
                                id: empId,
                                name: record.employeePersonalInformationFullName,
                                // This tracks Hours Worked (Table 2)
                                workHoursMonthly: new Array(12).fill(0),
                                workHoursGrandTotal: 0,
                                // This tracks Overtime Summary (Table 3)
                                otMonthlyTotals: new Array(12).fill(0),
                                otGrandTotal: 0
                            };
                        }

                        const emp = locationMap[locName].employees[empId];

                        // 1. Calculate Hours Worked (using the new field from your backend)
                        const hWorked = record.hoursWorked || 0;
                        emp.workHoursMonthly[monthIdx] += hWorked;
                        emp.workHoursGrandTotal += hWorked;

                        // 2. Calculate Overtime Summary
                        const otSummary = record.overtimeSummary || 0;
                        emp.otMonthlyTotals[monthIdx] += otSummary;
                        emp.otGrandTotal += otSummary;
                    });
                });
            });
        });

        const sortedLocationNames = Object.keys(locationMap).sort((a, b) => {
            if (a === "No location") return 1;
            if (b === "No location") return -1;
            return a.localeCompare(b);
        });

        // --- 2. CREATE WORKSHEETS PER LOCATION ---
        sortedLocationNames.forEach(locName => {
            const locationData = locationMap[locName];
            const worksheet = workbook.addWorksheet(locName);

            const sectionsArray = Object.values(locationData.sections);
            const employeesArray = Object.values(locationData.employees).sort((a, b) => a.name.localeCompare(b.name));
            
            const gap = 2; 
            const table2StartCol = 1 + sectionsArray.length + gap + 1;

            // --- TABLE 1 (LEFT): MONTH VS SECTIONS (COUNTS HOURS WORKED) ---
            worksheet.mergeCells(1, 1, 1, 1 + sectionsArray.length);
            worksheet.getCell(1, 1).value = `SECTION MONTHLY HOURS WORKED`;
            const headerRowLeft = worksheet.getRow(2);
            headerRowLeft.getCell(1).value = "Month";
            sectionsArray.forEach((sec, idx) => headerRowLeft.getCell(2 + idx).value = sec.description);

            allMonths.forEach((monthName, monthIndex) => {
                const row = worksheet.getRow(3 + monthIndex);
                row.getCell(1).value = monthName;
                sectionsArray.forEach((sec, sIdx) => {
                    // FIXED: Now reduces hoursWorked instead of OT fields
                    const total = sec.allRecords
                        .filter(r => new Date(r.date).getMonth() === monthIndex)
                        .reduce((sum, r) => sum + (r.hoursWorked || 0), 0);
                    row.getCell(2 + sIdx).value = total;
                    row.getCell(2 + sIdx).numFmt = '#,##0.00';
                });
            });

            // --- TABLE 2 (RIGHT): EMPLOYEE MATRIX (COUNTS HOURS WORKED) ---
            const matrixEndCol = table2StartCol + 14; 
            worksheet.mergeCells(1, table2StartCol, 1, matrixEndCol);
            worksheet.getCell(1, table2StartCol).value = `EMPLOYEE YEARLY MATRIX (HOURS WORKED)`;

            const headerRowRight = worksheet.getRow(2);
            headerRowRight.getCell(table2StartCol).value = "ID";
            headerRowRight.getCell(table2StartCol + 1).value = "Full Name";
            allMonths.forEach((m, idx) => headerRowRight.getCell(table2StartCol + 2 + idx).value = m.substring(0, 3));
            headerRowRight.getCell(matrixEndCol).value = "TOTAL";

            employeesArray.forEach((emp, empIdx) => {
                const row = worksheet.getRow(3 + empIdx);
                row.getCell(table2StartCol).value = emp.id;
                row.getCell(table2StartCol + 1).value = emp.name;
                // FIXED: Using workHoursMonthly
                emp.workHoursMonthly.forEach((total, mIdx) => {
                    row.getCell(table2StartCol + 2 + mIdx).value = total;
                    row.getCell(table2StartCol + 2 + mIdx).numFmt = '#,##0.00';
                });
                row.getCell(matrixEndCol).value = emp.workHoursGrandTotal;
                row.getCell(matrixEndCol).font = { bold: true };
                row.getCell(matrixEndCol).numFmt = '#,##0.00';
            });

            // --- TABLE 3 (BELOW): OVERTIME SUMMARY (ONLY COUNTS overtimeSummary) ---
            const otStartRow = 3 + employeesArray.length + 3; 
            
            worksheet.mergeCells(otStartRow, table2StartCol, otStartRow, matrixEndCol);
            const otTitle = worksheet.getCell(otStartRow, table2StartCol);
            otTitle.value = `EMPLOYEE YEARLY OVERTIME SUMMARY`;
            otTitle.font = { bold: true, size: 12 };
            otTitle.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEB9C' } }; 

            const otHeader = worksheet.getRow(otStartRow + 1);
            otHeader.getCell(table2StartCol).value = "ID";
            otHeader.getCell(table2StartCol + 1).value = "Full Name";
            allMonths.forEach((m, idx) => otHeader.getCell(table2StartCol + 2 + idx).value = m.substring(0, 3));
            otHeader.getCell(matrixEndCol).value = "TOTAL";

            employeesArray.forEach((emp, empIdx) => {
                const row = worksheet.getRow(otStartRow + 2 + empIdx);
                row.getCell(table2StartCol).value = emp.id;
                row.getCell(table2StartCol + 1).value = emp.name;
                // Using otMonthlyTotals (calculated from overtimeSummary)
                emp.otMonthlyTotals.forEach((total, mIdx) => {
                    row.getCell(table2StartCol + 2 + mIdx).value = total;
                    row.getCell(table2StartCol + 2 + mIdx).numFmt = '#,##0.00';
                });
                row.getCell(matrixEndCol).value = emp.otGrandTotal;
                row.getCell(matrixEndCol).font = { bold: true };
                row.getCell(matrixEndCol).numFmt = '#,##0.00';
            });

            // --- FINAL STYLING ---
            const styleRow = (row) => {
                row.eachCell(cell => {
                    if (cell.value) {
                        cell.font = { bold: true };
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
                        cell.alignment = { horizontal: 'center' };
                        cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
                    }
                });
            };
            styleRow(headerRowLeft);
            styleRow(headerRowRight);
            styleRow(otHeader);

            worksheet.eachRow(row => {
                row.eachCell(cell => {
                    cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
                });
            });

            worksheet.getColumn(1).width = 15;
            worksheet.getColumn(table2StartCol).width = 12;
            worksheet.getColumn(table2StartCol + 1).width = 30;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'MAN_HOUR_REPORT_(TOTAL).xlsx');
    }, []);

    /* const generateDownloadReportTotal = useCallback(async (data) => {
        const workbook = new ExcelJS.Workbook();

        const allMonths = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        // --- 1. RE-GROUP DATA BY LOCATION & CALCULATE OT ---
        const locationMap = {};

        data.forEach(monthItem => {
            monthItem.locations.forEach(loc => {
                const locName = loc.locationDescription || "No location";
                if (!locationMap[locName]) {
                    locationMap[locName] = {
                        description: locName,
                        sections: {},
                        employees: {} 
                    };
                }

                loc.sections.forEach(sec => {
                    const secName = sec.sectionDescription || "No Section";
                    if (!locationMap[locName].sections[secName]) {
                        locationMap[locName].sections[secName] = {
                            id: sec.sectionId,
                            description: secName,
                            allRecords: []
                        };
                    }
                    locationMap[locName].sections[secName].allRecords.push(...sec.list);

                    sec.list.forEach(record => {
                        const empId = record.employeePersonalInformationEmployeeId;
                        const monthIdx = new Date(record.date).getMonth();

                        if (!locationMap[locName].employees[empId]) {
                            locationMap[locName].employees[empId] = {
                                id: empId,
                                name: record.employeePersonalInformationFullName,
                                monthlyTotals: new Array(12).fill(0),
                                grandTotal: 0,
                                // Track Overtime separately
                                otMonthlyTotals: new Array(12).fill(0),
                                otGrandTotal: 0
                            };
                        }

                        // Standard Man-Hours (as per your original code)
                        const stdHours = (record.otRegular || 0) + (record.nighDiff || 0);
                        locationMap[locName].employees[empId].monthlyTotals[monthIdx] += stdHours;
                        locationMap[locName].employees[empId].grandTotal += stdHours;

                        // Sum of all requested OT fields
                        const otHours = (record.overtimeSummary || 0);
                        // const otHours = (record.otRegular || 0) +
                        //                 (record.otRestday || 0) +
                        //                 (record.otHolidaySpecial || 0) +
                        //                 (record.otHolidayRegular || 0) +
                        //                 (record.otRestdayHolidaySpecial || 0) +
                        //                 (record.otRestdayHolidayRegular || 0);
                        
                        locationMap[locName].employees[empId].otMonthlyTotals[monthIdx] += otHours;
                        locationMap[locName].employees[empId].otGrandTotal += otHours;
                    });
                });
            });
        });

        const sortedLocationNames = Object.keys(locationMap).sort((a, b) => {
            if (a === "No location") return 1;
            if (b === "No location") return -1;
            return a.localeCompare(b);
        });

        // --- 2. CREATE WORKSHEETS PER LOCATION ---
        sortedLocationNames.forEach(locName => {
            const locationData = locationMap[locName];
            const worksheet = workbook.addWorksheet(locName);

            const sectionsArray = Object.values(locationData.sections);
            const employeesArray = Object.values(locationData.employees).sort((a, b) => a.name.localeCompare(b.name));
            
            const gap = 2; 
            const table2StartCol = 1 + sectionsArray.length + gap + 1;

            // --- TABLE 1 (LEFT): MONTH VS SECTIONS ---
            worksheet.mergeCells(1, 1, 1, 1 + sectionsArray.length);
            worksheet.getCell(1, 1).value = `SECTION MONTHLY SUMMARY`;
            const headerRowLeft = worksheet.getRow(2);
            headerRowLeft.getCell(1).value = "Month";
            sectionsArray.forEach((sec, idx) => headerRowLeft.getCell(2 + idx).value = sec.description);

            allMonths.forEach((monthName, monthIndex) => {
                const row = worksheet.getRow(3 + monthIndex);
                row.getCell(1).value = monthName;
                sectionsArray.forEach((sec, sIdx) => {
                    const total = sec.allRecords
                        .filter(r => new Date(r.date).getMonth() === monthIndex)
                        .reduce((sum, r) => sum + (r.otRegular || 0) + (r.nighDiff || 0), 0);
                    row.getCell(2 + sIdx).value = total;
                    row.getCell(2 + sIdx).numFmt = '#,##0.00';
                });
            });

            // --- TABLE 2 (RIGHT): EMPLOYEE MATRIX (MAN-HOURS) ---
            const matrixEndCol = table2StartCol + 14; // ID + Name + 12 Months + Total
            worksheet.mergeCells(1, table2StartCol, 1, matrixEndCol);
            worksheet.getCell(1, table2StartCol).value = `EMPLOYEE YEARLY MATRIX (MAN-HOURS)`;

            const headerRowRight = worksheet.getRow(2);
            headerRowRight.getCell(table2StartCol).value = "ID";
            headerRowRight.getCell(table2StartCol + 1).value = "Full Name";
            allMonths.forEach((m, idx) => headerRowRight.getCell(table2StartCol + 2 + idx).value = m.substring(0, 3));
            headerRowRight.getCell(matrixEndCol).value = "TOTAL";

            employeesArray.forEach((emp, empIdx) => {
                const row = worksheet.getRow(3 + empIdx);
                row.getCell(table2StartCol).value = emp.id;
                row.getCell(table2StartCol + 1).value = emp.name;
                emp.monthlyTotals.forEach((total, mIdx) => {
                    row.getCell(table2StartCol + 2 + mIdx).value = total;
                    row.getCell(table2StartCol + 2 + mIdx).numFmt = '#,##0.00';
                });
                row.getCell(matrixEndCol).value = emp.grandTotal;
                row.getCell(matrixEndCol).font = { bold: true };
                row.getCell(matrixEndCol).numFmt = '#,##0.00';
            });

            // --- TABLE 3 (BELOW MATRIX): OVERTIME SUMMARY ---
            const otStartRow = 3 + employeesArray.length + 3; // Gap of 3 rows below standard matrix
            
            worksheet.mergeCells(otStartRow, table2StartCol, otStartRow, matrixEndCol);
            const otTitle = worksheet.getCell(otStartRow, table2StartCol);
            otTitle.value = `EMPLOYEE YEARLY OVERTIME SUMMARY`;
            otTitle.font = { bold: true, size: 12 };
            otTitle.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEB9C' } }; // Light Orange

            const otHeader = worksheet.getRow(otStartRow + 1);
            otHeader.getCell(table2StartCol).value = "ID";
            otHeader.getCell(table2StartCol + 1).value = "Full Name";
            allMonths.forEach((m, idx) => otHeader.getCell(table2StartCol + 2 + idx).value = m.substring(0, 3));
            otHeader.getCell(matrixEndCol).value = "TOTAL";

            employeesArray.forEach((emp, empIdx) => {
                const row = worksheet.getRow(otStartRow + 2 + empIdx);
                row.getCell(table2StartCol).value = emp.id;
                row.getCell(table2StartCol + 1).value = emp.name;
                emp.otMonthlyTotals.forEach((total, mIdx) => {
                    row.getCell(table2StartCol + 2 + mIdx).value = total;
                    row.getCell(table2StartCol + 2 + mIdx).numFmt = '#,##0.00';
                });
                row.getCell(matrixEndCol).value = emp.otGrandTotal;
                row.getCell(matrixEndCol).font = { bold: true };
                row.getCell(matrixEndCol).numFmt = '#,##0.00';
            });

            // --- FINAL STYLING ---
            const styleRow = (row) => {
                row.eachCell(cell => {
                    if (cell.value) {
                        cell.font = { bold: true };
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
                        cell.alignment = { horizontal: 'center' };
                        cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
                    }
                });
            };
            styleRow(headerRowLeft);
            styleRow(headerRowRight);
            styleRow(otHeader);

            worksheet.eachRow(row => {
                row.eachCell(cell => {
                    cell.border = { top:{style:'thin'}, left:{style:'thin'}, bottom:{style:'thin'}, right:{style:'thin'} };
                });
            });

            worksheet.getColumn(1).width = 15;
            worksheet.getColumn(table2StartCol).width = 12;
            worksheet.getColumn(table2StartCol + 1).width = 30;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'YEARLY_MANHOUR_DETAILED_REPORT.xlsx');
    }, []); */


    //oldest
    // const generateDownloadReportTotal = useCallback(async (data) => {
    //     const workbook = new ExcelJS.Workbook();

    //     const allMonths = [
    //         'January','February','March','April','May','June',
    //         'July','August','September','October','November','December'
    //     ];

    //     for (const monthItem of data) {
    //         const sortedLocations = [...monthItem.locations].sort((a, b) => {
    //             const descA = a.locationDescription;
    //             const descB = b.locationDescription;

    //             // If a is null/empty and b is not, a goes after b (return 1)
    //             if (!descA && descB) return 1;
    //             // If b is null/empty and a is not, a goes before b (return -1)
    //             if (descA && !descB) return -1;
                
    //             // Optional: Sort alphabetically for items that both have descriptions
    //             if (descA && descB) return descA.localeCompare(descB);

    //             return 0;
    //         });

    //         for (const location of sortedLocations) {
    //             const worksheet = workbook.addWorksheet(location.locationDescription ? location.locationDescription : "No location");

    //             // Define columns: first column = Month, then sections
    //             const columns = [
    //                 { header: 'Month', key: 'month', width: 20 },
    //                 ...location.sections.map(section => ({
    //                     header: section.sectionDescription ? section.sectionDescription : "No Section",
    //                     key: `section_${section.sectionId}`,
    //                     width: 30
    //                 }))
    //             ];
    //             worksheet.columns = columns;

    //             // Style header row
    //             const headerRow = worksheet.getRow(1);
    //             headerRow.eachCell((cell) => {
    //                 cell.font = { bold: true };
    //                 cell.alignment = { horizontal: 'center', vertical: 'middle' };
    //                 cell.border = {
    //                     top: { style: 'medium' }, left: { style: 'medium' },
    //                     bottom: { style: 'medium' }, right: { style: 'medium' }
    //                 };
    //                 cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
    //             });
    //             worksheet.getRow(1).height = 25;

    //             // Loop through all months
    //             allMonths.forEach((monthName, monthIndex) => {
    //                 const monthData = location.sections.map(section => {
    //                     // Sum totalWorkedHours (or otRegular + nighDiff) for this month
    //                     const totalHours = section.list
    //                         .filter(r => new Date(r.date).getMonth() === monthIndex)
    //                         .reduce((sum, r) => sum + r.otRegular + r.nighDiff, 0);
    //                     return totalHours;
    //                 });

    //                 const row = worksheet.addRow([
    //                     monthName,
    //                     ...monthData.map(val => val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
    //                 ]);

    //                 row.height = 20;
    //                 row.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    //                 row.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    //                 row.eachCell((cell, idx) => {
    //                     if (idx > 1) {
    //                         cell.alignment = { horizontal: 'center', vertical: 'middle' };
    //                         cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    //                     }
    //                 });
    //             });

    //             // Overall totals per section
    //             const overallRow = worksheet.addRow([
    //                 'Overall',
    //                 ...location.sections.map(section => {
    //                     const sectionTotal = section.list.reduce((sum, r) => sum + r.otRegular + r.nighDiff, 0);
    //                     return sectionTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //                 })
    //             ]);
    //             overallRow.eachCell((cell) => {
    //                 cell.font = { bold: true };
    //                 cell.alignment = { horizontal: 'center', vertical: 'middle' };
    //                 cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EAEAEA' } };
    //                 cell.border = { top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' } };
    //             });
    //             overallRow.height = 20;
    //         }
    //     }

    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //     saveAs(blob, 'MANHOUR_REPORT.xlsx');
    // }, []);
    
    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Man Hour"}</span>
                            </div>
                            <h3>Generate Man Hour Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row">
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Month</div>
                                    <div className="info-item-input">
                                        <Month month={month} setMonth={setMonth}/>
                                    </div>
                                    <span style={{
                                                visibility: (type === "PerDay" && !month) && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Year</div>
                                    <div className="info-item-input">
                                        <Year year={year} setYear={setYear}/>
                                    </div>
                                    <span style={{
                                                visibility: !year && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Classification</div>
                                    <div className="info-item-input">
                                        <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                                    </div>
                                    <span style={{
                                                visibility: !classificationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="info-item-holder row">
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Pay Type</div>
                                    <div className="info-item-input">
                                        <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                                    </div>
                                    <span style={{
                                                visibility: !payTypeId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Location</div>
                                    <div className="info-item-input">
                                        <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                                    </div>
                                    <span style={{
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column"></div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row" style={{gap: "2px"}}>
                                <button id="activeEmployeesGenerate"
                                    className="generate row" 
                                    onClick={generateTotal}
                                    > GENERATE TOTAL
                                </button>
                                <button id="activeEmployeesGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE PER DAY
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function ClassificationIdSelect({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function LocationIdSelect({locationId, setLocationId}){
    const handleSelectChange = (event) => {
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)"}}>
            <option value={0} >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
function Month({month, setMonth}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setMonth(event.target.value);
        setIsSelected(true);
    };

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    
    useEffect(() => {
        if(month !== "" && month !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [month]);

    return (
        <div>
            <select id="monthSSSReport-select" value={month} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" >Choose a month</option>
                {months.map((monthName, index) => (
                    <option key={index} value={monthName}>{monthName}</option>
                ))}
            </select>
        </div>
    );
};
function Year({year, setYear}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setYear(event.target.value);
        setIsSelected(true);
    };

    // Generate years from 2019 to the current year
    const getCurrentYear = () => new Date().getFullYear();
    const startYear = 2019;
    const years = Array.from({ length: getCurrentYear() - startYear + 1 }, (_, index) => (startYear + index).toString());

    useEffect(() => {
        if(year !== "" && year !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [year]);

    return (
        <div>
            <select id="yearSSSReport-select" value={year} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose a year</option>
            {years.map((yearName, index) => (
                <option key={index} value={yearName}>{yearName}</option>
            ))}
            </select>
        </div>
    );
};
function PayTypeIdSelect({payTypeId, setPayTypeId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayTypeId(event.target.value);
    };
    
    const [payTypeIds, setPayTypeIds] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/PayType/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setPayTypeIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payTypeId !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payTypeId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payTypeId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose pay type</option>
            {payTypeIds.map((payTypeId) => ( 
                SetPayTypeIds(payTypeId)
            ))}
            </select>
        </div>
    );
};
function SetPayTypeIds(payTypeId){
    return(
        <option id={"holidayType" + payTypeId.id} value={payTypeId.id}>{payTypeId.description}</option>
    )
    
}

export default ManHour
